/**
 * Catálogo de proveedores de logística (BYO + nativos Structura).
 */
import type { FeatureLifecycle } from "@/lib/feature-catalog";

export type LogisticsProviderId =
  | "entrega"
  | "zones"
  | "radius"
  | "cabify"
  | "uber_direct"
  | "pedidosya"
  | "rapiboy"
  | "zipnova"
  | "pickit"
  | "shipnow"
  | "treggo"
  | "andreani"
  | "oca"
  | "correo_argentino"
  | "enviopack";

export interface LogisticsProviderDef {
  id: LogisticsProviderId;
  label: string;
  description: string;
  featureId: string | null;
  kind: "native" | "carrier";
  defaultLifecycle: FeatureLifecycle;
}

export const LOGISTICS_PROVIDERS: LogisticsProviderDef[] = [
  {
    id: "entrega",
    label: "Métodos de entrega",
    description: "Retiro en local, domicilio o ambos, y aviso por WhatsApp",
    featureId: null,
    kind: "native",
    defaultLifecycle: "stable",
  },
  {
    id: "zones",
    label: "Zonas (CP, barrio o mapa)",
    description: "Cobertura por código postal, barrio, provincia o dibujando un área en el mapa",
    featureId: null,
    kind: "native",
    defaultLifecycle: "stable",
  },
  {
    id: "radius",
    label: "Radio en kilómetros",
    description: "Cobertura por distancia real desde tu sucursal (flota propia)",
    featureId: null,
    kind: "native",
    defaultLifecycle: "stable",
  },
  {
    id: "cabify",
    label: "Cabify",
    description: "Inmediato, mismo día y día siguiente",
    featureId: "cabify_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "uber_direct",
    label: "Uber Direct",
    description: "Courier on-demand Uber (pickup → cliente)",
    featureId: "uber_direct_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "pedidosya",
    label: "PedidosYa Delivery",
    description: "Courier on-demand (mock Fase 1)",
    featureId: "delivery_provider_pedidosya",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "rapiboy",
    label: "Rapiboy",
    description: "Courier Rapiboy (≠ Rappi Envíos)",
    featureId: "delivery_provider_rapiboy",
    kind: "carrier",
    defaultLifecycle: "beta",
  },


  {
    id: "zipnova",
    label: "Zipnova",
    description: "Cotización multi-carrier",
    featureId: "zipnova_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "pickit",
    label: "Pickit",
    description: "Puntos Pickit y envío a domicilio",
    featureId: "pickit_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "shipnow",
    label: "Shipnow",
    description: "Cotizá y despachá con tu cuenta Shipnow",
    featureId: "shipping_shipnow",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "treggo",
    label: "Treggo",
    description: "Creá y rastreá envíos con Treggo",
    featureId: "treggo_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "correo_argentino",
    label: "Correo Argentino",
    description: "MiCorreo — cotizar e importar envíos",
    featureId: "correo_argentino_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "oca",
    label: "OCA ePak",
    description: "Paquetería nacional OCA (ePak)",
    featureId: "oca_epak_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "andreani",
    label: "Andreani",
    description: "Cotizá, creá y rastreá con Andreani",
    featureId: "andreani_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
  {
    id: "enviopack",
    label: "Enviopack",
    description: "Correo nacional (Andreani, OCA, Correo Argentino)",
    featureId: "enviopack_shipping",
    kind: "carrier",
    defaultLifecycle: "beta",
  },
];

export function getLogisticsProvider(id: string): LogisticsProviderDef | undefined {
  return LOGISTICS_PROVIDERS.find((p) => p.id === id);
}

export function isLogisticsProviderId(id: string): id is LogisticsProviderId {
  return LOGISTICS_PROVIDERS.some((p) => p.id === id);
}
